import styled from 'styled-components';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from './type';

export const CreditCardAddressWrapper = styled.div<{
  variant?: ComponentVariants;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'CreditCardAddress', 'variant')
    )};
`;

CreditCardAddressWrapper.defaultProps = {
  variant: 'regular',
};
